export default __webpack_public_path__ + "static/tin-vet-f33c91ff4193ccebf35e6282af606d92.png";